import React from "react";
import { Link } from "react-router-dom";
import { config } from "../../pages/config";

const Cta = () => {
    return (
        <div className="ready-to-talk">
            <div className="container">
                <h3>Ready to talk?</h3>
                <p>Our team is here to answer your question about Elementeers Nucleons</p>
                <Link to={`${config.appUrl}contact-us`} className="btn btn-primary">Contact Us</Link>
            </div>
        </div>
    );
};

export default Cta;
